export const ajusteDiferencialRedondeo = (valor, decimales) => {
    if (decimales?.length === 0) return [];
    decimales.forEach((dec, index) => {
        decimales[index] = redondear(dec);
    });
    let ultimoIndex = decimales.length - 1;
    const diferencia = redondear(valor - redondear(decimales.reduce((acc, dec) => acc + dec, 0), 2), 2);
    decimales[ultimoIndex] = redondear(decimales[ultimoIndex] + diferencia, 2);
    return decimales;
};

export const ajusteDiferencialRedondeoJson = (valor, decimales, field) => {
    // COMPROBAMOS QUE EL CAMPO EXISTA
    if (!field) return [];
    // COMPORBAMOS QUE EXISTA UN ARRAY DE DECIMALES
    if (decimales?.length === 0) return [];
    decimales.forEach((dec, index) => {
        decimales[index][field] = redondear(dec[field]);
    });
    let ultimoIndex = decimales.length - 1;
    const diferencia = redondear(valor - redondear(decimales.reduce((acc, dec) => acc + dec[field], 0), 2), 2);
    decimales[ultimoIndex][field] = redondear(decimales[ultimoIndex][field] + diferencia, 2);
    return decimales;
};

// FUNCUON QUE REDONDEA UN NUMERO A UNA CANTIDAD DE DECIMALES DETERMINADA
export const redondear = (numero, decimales = 2) => {
    return numero?.toFixed ? parseFloat(numero?.toFixed(decimales)) : 0;
}


export const ajusteRedondeoEquitativoJson = (jsonArray, fields) => {
    let arrayData = [...jsonArray];
    fields.forEach(field => {
        // console.log(`Ajuste Redondeo Equitativo JSON: ${field}`, arrayData);
        if (!Array.isArray(arrayData) || !arrayData.length === 0 || !field) return [];

        // console.log(`SE INICIA EL AJUSTE DE REDONDEO EQUITATIVO PARA EL CAMPO: ${field}`);

        // 1. Calcular la suma total original y redondearla a 2 decimales
        const sumaOriginal = arrayData.reduce((sum, obj) => sum + (obj[field] || 0), 0);
        const sumaObjetivo = Math.round(sumaOriginal * 100) / 100;

        // 2. Redondear cada número individualmente a 2 decimales
        const valoresRedondeados = arrayData.map(obj => Math.round((obj[field] || 0) * 100) / 100)

        // 3. Calcular la suma de los números redondeados
        const sumaRedondeada = valoresRedondeados.reduce((sum, num) => sum + num, 0);

        // 4. Calcular la diferencia
        let diferencia = Math.round((sumaObjetivo - sumaRedondeada) * 100) / 100;

        // Crear copia del array para modificar
        let resultado = arrayData.map((obj, i) => ({ ...obj, [field]: valoresRedondeados[i] }));
        // console.log({ sumaOriginal, sumaRedondeada, diferencia });
        // 5. Si hay diferencia, ajustar
        if (diferencia !== 0) {
            // console.log(`Diferencia encontrada: ${diferencia}. Ajustando...`);
            // Calcular la pérdida/ganancia por redondeo para cada elemento
            const perdidas = arrayData.map((obj, index) => {
                const original = obj[field] || 0;
                return {
                    index: index,
                    original: original,
                    redondeado: valoresRedondeados[index],
                    perdida: original - valoresRedondeados[index]
                }
            });

            // Ordenar por la pérdida/ganancia más significativa según el tipo de diferencia
            let elementosOrdenados;
            if (diferencia > 0) {
                elementosOrdenados = perdidas.sort((a, b) => b.perdida - a.perdida);
                // resultado = resultado.sort((a, b) => b[field] - a[field]);
            } else {
                elementosOrdenados = perdidas.sort((a, b) => a.perdida - b.perdida);
                // resultado = resultado.sort((a, b) => a[field] - b[field]);
            }

            // Calcular el ajuste por elemento (centavos)
            const ajustePorElemento = diferencia > 0 ? 0.01 : -0.01;
            const elementosAjustar = Math.abs(Math.round(diferencia * 100));

            // Aplicar ajustes a los elementos que más lo necesitan
            for (let i = 0; i < elementosAjustar && i < elementosOrdenados.length; i++) {
                // console.log(elementosOrdenados[i]);
                const indiceAjustar = elementosOrdenados[i].index;
                resultado[indiceAjustar][field] = Math.round((resultado[indiceAjustar][field] + ajustePorElemento) * 100) / 100;
                resultado[indiceAjustar].AjusteRedondeo = true; // Marcar como ajustado
                resultado[indiceAjustar].AjusteRedondeoDiff = resultado[indiceAjustar][field] - valoresRedondeados[indiceAjustar];
                resultado[indiceAjustar].valorOriginal = resultado[indiceAjustar][field]


                // console.log(`Ajustando ${field} elemento en índice ${indiceAjustar}: ${resultado[indiceAjustar][field]}, diferencia: ${diferencia}`, resultado[indiceAjustar].AjusteRedondeo, field);
            }
            // imprimir en consola los elementos ajustados
            // console.log({
            //     original: jsonArray,
            //     redondeados: resultado,
            //     sumaOriginal: sumaOriginal,
            //     sumaObjetivo: sumaObjetivo,
            //     diferencia: diferencia,
            //     ajustado: true,
            //     perdidas: perdidas.map(p => ({
            //         index: p.index,
            //         original: p.original,
            //         redondeado: valoresRedondeados[p.index],
            //         final: resultado[p.index][field],
            //         perdidaOriginal: p.perdida,
            //         ajustado: resultado[p.index][field] !== valoresRedondeados[p.index]
            //     }))
            // });
        }
        arrayData = resultado;
    })
    return arrayData;
}